<div class="container-fuid bg-white default-boxrounded dialog-withdraw p-3">
  <div class="row">
    <div class="col-7">
      <h2 translate="Modals.EditSignatureData.Title"></h2>
    </div>
  </div>
  <div class="py-3">
    <span class="float-start" translate="Modals.EditSignatureData.AllowedSignatureProviders"></span>
    <div>
      <a class="form-control d-flex subheader align-items-center justify-content-between w-100"
        [class.disabled]="dropdownDisabled" [class.pe-none]="dropdownDisabled"
        [style.opacity]="dropdownDisabled ? '0.65' : null"
        [style.background-color]="dropdownDisabled ? '#e9ecef' : null"
        [style.cursor]="dropdownDisabled ? 'not-allowed' : null"
        [attr.data-bs-toggle]="dropdownDisabled ? null : 'dropdown'" aria-expanded="false"
        (click)="$event.stopPropagation();">
        <span class="text-truncate flex-grow-1 me-2">{{getSelectedSignatureProviders()}}</span>
        @if (!dropdownDisabled) {
          <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
        }
      </a>
      <div class="dropdown d-flex" id="dropdownFilterMenu" (change)="applySignatureProvicerSelection($event)">
        <ul class="dropdown-menu dashboard-filter-dropdown">
          <li class="option-item-small description"
          translate="Modals.EditSignatureData.AllowedSignatureProviders"></li>
          @for (signatureProvider of signatureProviders; track signatureProvider; let i = $index) {
            <li class="option-item-small w-100">
              <input type="checkbox" class="checkbox form-check-input"
                name="signatureProvider_{{signatureProvider.name}}"
                [id]="getProviderValue(signatureProvider)" [value]="getProviderValue(signatureProvider)"
                [checked]="checkIfProviderIsSelected(signatureProvider)"
                [disabled]="disableSignatureProviders || isDisabled(signatureProvider)">
                <label class="form-check-label" [for]="getProviderValue(signatureProvider)"
                (click)="$event.stopPropagation();"> {{ signatureProvider.name }}</label>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
    <div class="mt-2 mt-5 d-table w-100">
      <span class="float-start">
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="close()"
        translate="Button.Back"></button>
      </span>
      <span class="float-end">
        <button type="button" class="btn btn-sm btn-primary" [disabled]="selectedSignatureProviders.length === 0 || !hasSelectionChanged"
        (click)="save()" translate="Button.Confirm"></button>
      </span>
    </div>
  </div>